export function omitNull(obj: Record<any, any>): any {
  return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== null));
}

export function omitUndefined(obj: Record<any, any>): any {
  return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
}
